'use client';

import React from 'react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { QueryClientProvider } from '@tanstack/react-query';

import { getQueryClient } from 'app/get-query-client';

export function WidgetProviders({ children }: { children: React.ReactNode }) {
    // The main app's client, not a second one: main-app modules read and seed the cache
    // imperatively through getQueryClient(), and a separate provider client never saw
    // those writes (and ran with library defaults instead of the app's).
    const queryClient = getQueryClient();

    return (
        <NuqsAdapter>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </NuqsAdapter>
    );
}
